import {
  MimeType
} from "./mimeTypes";
const fileSaver = require("file-saver");

export function downloadBlob(blob: Blob, name: string, extension ? : string | null) {
  const fileName = extension ? `${name}.${extension}` : name;
  fileSaver.saveAs(blob, fileName);
}

export function downloadString(string: string, name: string, extension: string) {
  const blob = new Blob([string], {
    type: MimeType[extension]
  });
  return downloadBlob(blob, name, extension);
}

export function downloadBuffer(buffer: ArrayBuffer | Uint8Array, name: string, extension: string) {
  const blob = new Blob([buffer], {
    type: MimeType[extension]
  });
  return downloadBlob(blob, name, extension);
}

export function downloadUrl(url: string, name: string, extension: string) {
  throw new Error('TO DO');
}

export function bufferToString(buffer: ArrayBuffer | Uint8Array | Uint8Array) {
  let text = '';
  const array = new Uint8Array(buffer);
  const len = array.byteLength;
  for (let i = 0; i < len; i++) {
    text += String.fromCharCode(array[i]);
  }
  return text;
}

export function stringToBuffer(string: string) {
  const array = new Uint8Array(string.length);
  const len = string.length;
  for (let i = 0; i < len; i++) {
    array[i] = string.charCodeAt(i);
  }
  return array;
}

export function stringToArrayBuffer(string: string) {
  const buffer = new ArrayBuffer(string.length);
  const array = new Uint8Array(buffer);
  const len = string.length;
  for (let i = 0; i < len; i++) {
    array[i] = string.charCodeAt(i);
  }
  return buffer;
}


// WEBPACK FOOTER //
// ./src/logic/util.ts